import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import NewButton from 'components/molecules/NewButton';

const AlertDialog = (props) => {
  const { t } = useTranslation();
  const {
    children,
    isOpen,
    title,
    description,
    submitName = t('확인'),
    closeCallBack = (f) => f,
  } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (isOpen !== open) {
      setOpen(isOpen);
    }
    // eslint-disable-next-line
  }, [isOpen]);

  const handleClose = () => {
    setOpen(false);
    closeCallBack();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {!!title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {children}
          <NewButton onClick={handleClose}>{submitName}</NewButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default AlertDialog;
